import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
} from 'rxjs/operators';
import { SaleChannelService } from '@core/services';
import { CanalVenta } from '@core/models';
import {
  SALE_CHANNEL_CREATE_VIEW,
  SALE_CHANNEL_EDIT_MODE,
  SALE_CHANNEL_FIND_ALL,
  SALE_CHANNEL_FIND_ALL_SUCCESS,
  SALE_CHANNEL_UPDATE_LOADING,
  SALE_CHANNEL_FAILURE,
  SALE_CHANNEL_UPDATE_VIEW,
  SALE_CHANNEL_UPDATE_ID,
  SALE_CHANNEL_FIND,
  SALE_CHANNEL_FIND_SUCCESS,
  SERVICE_FAILURE,
} from '@store/actions';

@Injectable()
export class SaleChannelEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private saleChannelService: SaleChannelService
  ) {}

  createView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SALE_CHANNEL_CREATE_VIEW),
      mergeMap(() => [
        SALE_CHANNEL_EDIT_MODE({ editMode: true, isEditing: false }),
      ])
    )
  );

  updateView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SALE_CHANNEL_UPDATE_VIEW),
      mergeMap(({ saleChannelId }) => [
        SALE_CHANNEL_UPDATE_ID({ saleChannelId }),
        SALE_CHANNEL_EDIT_MODE({ editMode: true, isEditing: true }),
      ])
    )
  );

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SALE_CHANNEL_FIND),
      mergeMap(({ id }) => {
        this.store.dispatch(SALE_CHANNEL_UPDATE_LOADING({ loading: true }));
        return this.saleChannelService.find(id).pipe(
          mergeMap(({ data }) => {
            const [saleChannel] = data as CanalVenta[];
            return [
              SALE_CHANNEL_FIND_SUCCESS({ saleChannel }),
              SALE_CHANNEL_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              SERVICE_FAILURE({ error }),
              SALE_CHANNEL_FAILURE({ error }),
              SALE_CHANNEL_UPDATE_LOADING({ loading: false })
            )
          )
        );
      })
    )
  );

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SALE_CHANNEL_FIND_ALL),
      mergeMap(() => {
        this.store.dispatch(SALE_CHANNEL_UPDATE_LOADING({ loading: true }));
        return this.saleChannelService.findAll().pipe(
          mergeMap(({ data }) => {
            const saleChannelList = data as CanalVenta[];
            return [
              SALE_CHANNEL_FIND_ALL_SUCCESS({ saleChannelList }),
              SALE_CHANNEL_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              SERVICE_FAILURE({ error }),
              SALE_CHANNEL_FAILURE({ error }),
              SALE_CHANNEL_UPDATE_LOADING({ loading: false })
            )
          )
        );
      })
    )
  );
}
